import getCdnResource from '~/shared/cdn/getCdnResource';

const getCdnLogoImg = (name: string) => getCdnResource(`logos/${name}.svg`);

export default getCdnLogoImg;
